import React from "react";

const data = [
  {
    id: "UINextMigration",
    title: "Migration to UI-next Library",
    summary: () => (
      <p>
        OHIF 3.13 will complete the migration to our new UI-next library.
      </p>
    ),
    description: () => (
      <div className="flex flex-col space-y-5">
        <p>
          The new library will contain a new OHIF theming guide, complete with
          theme examples that can be quickly applied using simple instructions.
          All OHIF UI components will have an example showcase, updated
          documentation, and the ability to quickly grab and apply to your own
          instance of OHIF, making customization simpler and more streamlined.
          We'll also include some new utility UI components, such as a smart
          scrollbar.
        </p>
      </div>
    )
  },
  {
    id: "NewStudyListDesign",
    title: "New Study List Design",
    summary: () => (
      <p>
        We will overhaul the standard Study List that is packaged with OHIF,
        providing an improved user experience, simpler implementation, and more
        customization options.
      </p>
    ),
    description: () => (
      <div className="flex flex-col space-y-5">
        <p>
          We're also introducing new worklist utilities such as an improved
          study launcher with custom options and the ability to tailor the
          worklist to custom workflows.
        </p>
      </div>
    )
  },
  {
    id: "SegmentationOptimization",
    title: "Segmentation Optimization",
    summary: () => (
      <p>
        As we have pushed a number of new segmentation options in recent
        updates, the 3.13 update will focus on stabilizing current segmentation
        offerings, integrating community feedback into the design, and
        optimizing performance.
      </p>
    ),
    description: () => (
      <div className="flex flex-col space-y-5">
      </div>
    )
  },
  {
    id: "FHIRPACSIntegration",
    title: "FHIR PACS Integration",
    summary: () => (
      <p>
        OHIF will continue to expand integration with PACS systems via the FHIR
        (Fast Healthcare Interoperability Resource) standard.
      </p>
    ),
    description: () => (
      <div className="flex flex-col space-y-5">
        <p>
          We will build a new interface to facilitate FHIR integration in the
          OHIF application, including a demonstration and deployment guide.
        </p>
      </div>
    )
  },
  {
    id: "GeneralStabilityFixes",
    title: "General Stability Fixes",
    summary: () => (
      <p>
        The next update will bring a number of important stability fixes,
        including optimizations for measurements, calibration, and rendering.
      </p>
    ),
    description: () => (
      <div className="flex flex-col space-y-5">
        <p>
          We will also improve our security patching process to better support
          our long term support model.
        </p>
      </div>
    )
  }
];

export default data;
